module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-15-b092534d9ed0f41992305f6f4615a83a.jpg";